module.exports = __webpack_public_path__ + "img/shahr-financial-group.f92a388.png";